export default function getHeat(raw, possible) {
  let heat = Math.round(raw / possible * 10)
  if (heat > 10) {
    return 10
  } else if (heat < 1) {
    return 1
  } else {
    return heat
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getHeat.js